module.exports = __webpack_public_path__ + "img/shequn.84015c99.png";